import PropTypes from 'prop-types'
import { getContext } from 'recompose'

// const themed = BaseComponent => {
//   const ThemedComponent = getContext({ theme: PropTypes.object })(BaseComponent)
//   ThemedComponent.defaultProps = BaseComponent.defaultProps
//   return ThemedComponent
// }
// export default themed

export default Component => getContext({ theme: PropTypes.object })(Component)



// WEBPACK FOOTER //
// ./ui/Theme/themed.js